<template>
  <div class="bg-white inline-block rounded-lg p-4">
    <img
      :src="qrCode"
      alt=""
      class="w-full h-auto"
    >
  </div>
</template>

<script setup lang="ts">
import { COOKIES } from '#shared/constants/cookies'

const props = withDefaults(defineProps<{
  size?: 'md' | 'sm'
}>(), {
  size: 'md',
})

const rtsessionIdCookie = useCookie(COOKIES.session)

const qrCode = ref('')

const computedSize = computed(() => {
  return {
    sm: 120,
    md: 140,
  }[props.size]
})

async function getQrCodeImage(): Promise<string> {
  const { data }: { data: Ref<string> } = await useFetch('/api/app-qr-code', {
    query: {
      rtsessionid: rtsessionIdCookie.value,
      margin: 0,
      width: computedSize.value,
    },
  })
  return data.value
}
qrCode.value = await getQrCodeImage()
</script>
